module.exports = __webpack_public_path__ + "img/fb8b3ce.png";